<template>
  <page>
    <div v-if="!newMode" slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New Promotion Factor</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Promotion Factor</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query Promotion Factor</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs4 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.pFact_product }}</v-subheader>
                <div class="queryValue" v-for="item in filter_pFact_productList" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-autocomplete
                  :label="labels.pFact_product"
                  :items="pFact_productList"
                  v-model="form.pFact_product"
                  item-text="value"
                  item-value="code"
                  data-vv-name="pFact_product"
                  :data-vv-as="labels.pFact_product"
                  :error-messages="errors.collect('pFact_product')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs4 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.pFact_promo }}</v-subheader>
                <div class="queryValue" v-for="item in filter_pFact_promoList" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-autocomplete
                  :label="labels.pFact_promo"
                  :items="pFact_promoList"
                  v-model="form.pFact_promo"
                  item-text="value"
                  item-value="code"
                  data-vv-name="pFact_promo"
                  :data-vv-as="labels.pFact_promo"
                  :error-messages="errors.collect('pFact_promo')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs4 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.pFact_fact1 }}</v-subheader>
                <div class="queryValue" v-for="item in filter_pFact_fact1List" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-autocomplete
                  :label="labels.pFact_fact1"
                  :items="pFact_fact123List"
                  v-model="form.pFact_fact1"
                  item-text="value"
                  item-value="code"
                  data-vv-name="pFact_fact1"
                  :data-vv-as="labels.pFact_fact1"
                  :error-messages="errors.collect('pFact_fact1')"
                  v-validate="'max:4'"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs4 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.pFact_fact2 }}</v-subheader>
                <div class="queryValue" v-for="item in filter_pFact_fact2List" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-autocomplete
                  :label="labels.pFact_fact2"
                  :items="pFact_fact123List"
                  v-model="form.pFact_fact2"
                  item-text="value"
                  item-value="code"
                  data-vv-name="pFact_fact2"
                  :data-vv-as="labels.pFact_fact2"
                  :error-messages="errors.collect('pFact_fact2')"
                  v-validate="'max:4'"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs4 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.pFact_fact3 }}</v-subheader>
                <div class="queryValue" v-for="item in filter_pFact_fact3List" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-autocomplete
                  :label="labels.pFact_fact3"
                  :items="pFact_fact123List"
                  v-model="form.pFact_fact3"
                  item-text="value"
                  item-value="code"
                  data-vv-name="pFact_fact3"
                  :data-vv-as="labels.pFact_fact3"
                  :error-messages="errors.collect('pFact_fact3')"
                  v-validate="'max:4'"
                ></v-autocomplete>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs4 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.pFact_fact4 }}</v-subheader>
                <div class="queryValue" v-for="item in filter_pFact_fact4List" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-autocomplete
                  :label="labels.pFact_fact4"
                  :items="pFact_fact456List"
                  v-model="form.pFact_fact4"
                  item-text="value"
                  item-value="code"
                  data-vv-name="pFact_fact4"
                  :data-vv-as="labels.pFact_fact4"
                  :error-messages="errors.collect('pFact_fact4')"
                  v-validate="'max:4'"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs4 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.pFact_fact5 }}</v-subheader>
                <div class="queryValue" v-for="item in filter_pFact_fact5List" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-autocomplete
                  :label="labels.pFact_fact5"
                  :items="pFact_fact456List"
                  v-model="form.pFact_fact5"
                  item-text="value"
                  item-value="code"
                  data-vv-name="pFact_fact5"
                  :data-vv-as="labels.pFact_fact5"
                  :error-messages="errors.collect('pFact_fact5')"
                  v-validate="'max:4'"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs4 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.pFact_fact6 }}</v-subheader>
                <div class="queryValue" v-for="item in filter_pFact_fact6List" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-autocomplete
                  :label="labels.pFact_fact6"
                  :items="pFact_fact456List"
                  v-model="form.pFact_fact6"
                  item-text="value"
                  item-value="code"
                  data-vv-name="pFact_fact6"
                  :data-vv-as="labels.pFact_fact6"
                  :error-messages="errors.collect('pFact_fact6')"
                  v-validate="'max:4'"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container fluid grid-list-lg>
            <v-layout>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
              <span>Cancel</span>
              <v-icon right dark>mdi-cancel</v-icon>
            </v-btn>
            <v-btn :disabled="queryMode" color="primary" dark class="mr-2" @click="doSave" :loading="submitting">
              {{ newMode ? 'Save' : '' }}{{ reviewMode ? 'Update' : '' }}
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </v-container>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Promotion Rate',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'promotionRateList' }
        }
      ],
      labels: {
        pFact_product: 'Product',
        pFact_promo: 'Promotion',
        pFact_fact1: 'Factor 1',
        pFact_fact2: 'Factor 2',
        pFact_fact3: 'Factor 3',
        pFact_fact4: 'Factor 4',
        pFact_fact5: 'Factor 5',
        pFact_fact6: 'Factor 6',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        actionKey: 'PROMOTION_FACTOR',
        pFact_product: '',
        pFact_promo: '',
        pFact_fact1: '',
        pFact_fact2: '',
        pFact_fact3: '',
        pFact_fact4: '',
        pFact_fact5: '',
        pFact_fact6: ''
      },
      newMode: false,
      queryMode: false,
      reviewMode: false,
      submitting: false,
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: undefined,
      pFact_productList: [],
      pFact_promoList: [],
      pFact_fact123List: [],
      pFact_fact456List: []
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    doSetUpParams() {
      // To Direct Access on the Data property
      // Please change on the index number if there's any changes in adding the side menu
      this.sideFunction[0].params.params = { from_product: this.objParam.pFact_product, from_promo: this.objParam.pFact_promo }
    },
    async doFetchProduct() {
      const apiURI = this.menu.getRelatedData
      if (apiURI) {
        this.loading = true
        try {
          const relatedTask = { actionKey: 'RELATED_PRODUCT' }
          const result = await this.$http.get(expandURI(apiURI, relatedTask))
          const { data } = result.data
          this.pFact_productList = []
          if (data) {
            data.map((productList) => {
              const convertList = {
                code: productList.product,
                value: productList.product + ' - ' + productList.productDesc
              }
              this.pFact_productList.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doFetchPromotion() {
      const apiURI = this.menu.getRelatedData
      if (apiURI) {
        this.loading = true
        try {
          const relatedTask = { actionKey: 'RELATED_PROMOTION' }
          const result = await this.$http.get(expandURI(apiURI, relatedTask))
          const { data } = result.data
          this.pFact_promoList = []
          if (data) {
            data.map((promoList) => {
              const convertList = {
                code: promoList.promo_campaign,
                value: promoList.promo_campaign + ' - ' + promoList.promo_description
              }
              this.pFact_promoList.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doFetchFactor() {
      const apiURI = this.menu.getRelatedData
      if (apiURI) {
        this.loading = true
        try {
          const relatedTask = { actionKey: 'RELATED_FACTOR_ISNUM' }
          const result = await this.$http.get(expandURI(apiURI, relatedTask))
          const { data } = result.data
          this.pFact_fact123List = []
          this.pFact_fact456List = []
          if (data) {
            data.map((factortList) => {
              if (factortList.factorIsNum === false) {
                const convertList = {
                  code: factortList.factor,
                  value: factortList.factor + ' - ' + factortList.factorDesc
                }
                this.pFact_fact123List.push(convertList)
              } else {
                const convertList = {
                  code: factortList.factor,
                  value: factortList.factor + ' - ' + factortList.factorDesc
                }
                this.pFact_fact456List.push(convertList)
              }
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doFetch() {
      const apiURI = this.menu.getDetail
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.put(apiURI, this.objParam)
          const { data } = result.data
          if (data) {
            this.form.actionKey = data.promoFactDto.actionKey
            this.form.pFact_product = data.promoFactDto.pFact_product
            this.form.pFact_promo = data.promoFactDto.pFact_promo
            this.form.pFact_fact1 = data.promoFactDto.pFact_fact1
            this.form.pFact_fact2 = data.promoFactDto.pFact_fact2
            this.form.pFact_fact3 = data.promoFactDto.pFact_fact3
            this.form.pFact_fact4 = data.promoFactDto.pFact_fact4
            this.form.pFact_fact5 = data.promoFactDto.pFact_fact5
            this.form.pFact_fact6 = data.promoFactDto.pFact_fact6
            this.createdBy = data.createdBy
            this.createdDate = data.createdDate
            this.modifiedBy = data.modifiedBy
            this.modifiedDate = data.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'promotionFactorList' })
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
            // } else {
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.doCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.doUpdate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.campaignParam.menu
    },
    modeParam() {
      return this.$route.params.paramMode
    },
    objParam() {
      return this.$route.params.paramObjRes
    },
    filter_pFact_productList() {
      return this.pFact_productList.filter((list) => {
        return list.code === this.form.pFact_product
      })
    },
    filter_pFact_promoList() {
      return this.pFact_promoList.filter((list) => {
        return list.code === this.form.pFact_promo
      })
    },
    filter_pFact_fact1List() {
      return this.pFact_fact123List.filter((list) => {
        return list.code === this.form.pFact_fact1
      })
    },
    filter_pFact_fact2List() {
      return this.pFact_fact123List.filter((list) => {
        return list.code === this.form.pFact_fact2
      })
    },
    filter_pFact_fact3List() {
      return this.pFact_fact123List.filter((list) => {
        return list.code === this.form.pFact_fact3
      })
    },
    filter_pFact_fact4List() {
      return this.pFact_fact456List.filter((list) => {
        return list.code === this.form.pFact_fact4
      })
    },
    filter_pFact_fact5List() {
      return this.pFact_fact456List.filter((list) => {
        return list.code === this.form.pFact_fact5
      })
    },
    filter_pFact_fact6List() {
      return this.pFact_fact456List.filter((list) => {
        return list.code === this.form.pFact_fact6
      })
    }
  },
  created() {
    this.doFetchProduct()
    this.doFetchPromotion()
    this.doFetchFactor()
    if (this.modeParam === 'create') {
      this.newMode = true
    } else if (!this.modeParam) {
      this.doCancel()
    } else {
      if (this.modeParam === 'query') {
        this.queryMode = true
      } else if (this.modeParam === 'review') {
        this.reviewMode = true
      }
      this.doSetUpParams()
      this.doFetch()
    }
  },
  mixins: [MessageMixin],
  components: {
    SideFunctionMenu
  }
}
</script>
